define([
    "./hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.constant("hereMapsConstant", {
        NAVIGATE_MODE: "navigate",
        DRAWING_MODE: "drawing",
        FREEHAND_DRAWING_MODE: "freehandDrawing",
        RECT_SELECTION: "rectSelection",
    });
});